import React from 'react'
import ReactSelect, { components } from 'react-select'
import { Icon } from '@st-operations/uikit/src/v2/index.js'

import { SelectProps, SelectDefaultProps } from './constants'

import './styles.scss'

// const MultiValueLabel = (props) => {
//   let onClick = (e) => {
//     const { data, selectProps } = props
//     if (selectProps.onValueClick) {
//       selectProps.onValueClick(data, e)
//     }
//   }

//   return (
//     <div onClick={onClick} style={{ cursor: 'pointer' }}>
//       <components.MultiValueLabel {...props} />
//     </div>
//   )
// }

// const MultiValueRemove = (props) => {
//   return (
//     <button {...props.innerProps}>
//       <Icon icon="delete" type="fill" width="16px" height="16px" color="#13682B" />
//     </button>
//   )
// }

const Select = ({
  options,
  placeholder,
  onChange,
  onInputChange,
  className,
  isSearchable,
  isDisabled,
  label,
  description,
  ...props
}) => {
  return (
    <div className={`st-react-select ${className || ''}`}>
      <div className="st-react-select__label-wrapper">
        <If condition={label}>
          <label className="st-react-select__label">{label}</label>
        </If>
        <If condition={description}>
          <span className="st-react-select__caption">{description}</span>
        </If>
      </div>
      <ReactSelect
        classNamePrefix="st-react-select"
        options={options}
        onChange={onChange}
        onInputChange={onInputChange}
        isDisabled={isDisabled}
        isSearchable={isSearchable}
        noOptionsMessage={() => null}
        placeholder={placeholder}
        maxMenuHeight={300}
        // onValueClick={onValueClick}
        // components={{ MultiValueLabel, MultiValueRemove }}
        {...props}
      />
    </div>
  )
}

Select.propTypes = SelectProps
Select.defaultProps = SelectDefaultProps

export default React.memo(Select)
